import React from "react";
import { Drawer } from "../../components/Modals";
import ProjectDashboardPage from "./ProjectDashboardPage";

interface ProjectDashboardDrawerProps {
  isVisible: boolean;
  setShowModal: (show: boolean) => void;
  projectId: string;
}

const ProjectDashboardDrawer: React.FC<ProjectDashboardDrawerProps> = ({ 
  isVisible = false, 
  setShowModal, 
  projectId 
}) => {
  return (
    <>
      <Drawer
        isOpen={isVisible}
        onClose={() => setShowModal(false)}
        position="right"
        size={80}
      >
        <div className="relative h-[100vh] flex flex-col">
          <ProjectDashboardPage projectId={projectId} />
        </div>
      </Drawer>
    </>
  );
};

export default ProjectDashboardDrawer; 